/* eslint-disable max-len */
const Icon: React.FC = () => (
  <svg aria-hidden="true" height="36" role="presentation" viewBox="0 0 36 36" width="36">
    <title>Close Icon</title>
    <path
      fill="currentColor"
      d="M19.414 18l4.243 4.243a1 1 0 0 1-1.414 1.414L18 19.414l-4.243 4.243a1 1 0 0 1-1.414-1.414L16.586 18l-4.243-4.243a1 1 0 0 1 1.414-1.414L18 16.586l4.243-4.243a1 1 0 0 1 1.414 1.414L19.414 18z"
    />
  </svg>
);

export default Icon;
